<template>
  <div class="container" ref="box">
    <div class="school-body">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="classheader">
                  <el-page-header @back="goBack" content="课程详情">
                  </el-page-header>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin: 20px">
              <el-col :span="6">
                <div class="classimg_wrapper" :style="{
                    backgroundImage: 'url(' + curriculumInfo.img_url + ')',
                  }"></div>
              </el-col>
              <el-col :span="18">
                <div class="classdesc_wrapper">
                  <el-row>
                    <el-col :span="24">
                      <div class="classdesc_title" style="font-weight: 500">
                        {{ curriculumInfo.title }}
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        课程简介:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light" style="font-size: 14px">
                        {{ curriculumInfo.curriculum_desc }}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        课程节数:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">
                        {{ curriculumInfo.number_of_courses }}节
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        建议年龄:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">
                        {{ curriculumInfo.for_grade }}
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        建议时长:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">
                        {{ curriculumInfo.suggested_duration }}
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">
                        课程难度:
                      </div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">
                        <el-rate style="float: left; margin-top: 5px" v-model="curriculumInfo.difficulty" disabled :colors="colors">
                        </el-rate>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div class="classlist">
                  <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="课程大纲" name="first">
                      <el-row class="classlist_wrapper" v-for="(item, index) of curriculumMaterialList" :key="index">
                        <el-col :span="2">
                          <div class="classlist-imgwrapper">
                            <el-image v-if="item.img_url" class="classimg_wrapper_img" :src="item.img_url" fit="fill"></el-image>
                          </div>
                        </el-col>

                        <el-col :span="18">
                          <div class="classlist-content">
                            <div class="classlist-content-title">
                              <span class="coursetitle">
                                <span>第{{ index + 1 }}讲</span>
                                {{ item.title }}
                              </span>
                            </div>
                            <div class="classlist-content-desc">
                              <el-tooltip class="item" effect="light" :content="item.desc" placement="top-start">
                                <span>{{ item.desc }} </span>
                              </el-tooltip>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="classlist-btn">
                            <el-button round icon="el-icon-monitor" type="primary" @click="prepare(item)">备课</el-button>
                          </div>
                        </el-col>
                      </el-row>
                    </el-tab-pane>

                    <el-tab-pane label="课程说明" name="third" v-if="
                        curriculumInfo.markdown_explain &&
                          $store.state.user.schoolInfo.prepareContentAuth && 
                          $store.state.user.userInfo.prepareContentAuth
                      ">
                      <mavon-editor v-model="curriculumInfo.markdown_explain" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getTchTeachingPlan,
  tchGetStuTchPlanListByTchId,
  tchSaveTchWorkScore,
} from '@/api/classroom/teacher_api'

import {
  updateStuUserPassword,
  updateTchPlanSignState,
  saveOldSysScWork,
  saveOldSysJrWork,
  getPrepareCurrculumMaterialList,
} from '@/api/educational'

import { getStuScratchWorks, getStuJrcodeWorks } from '@/utils/scratch3_api'

import CryptoJS from 'crypto-js'

export default {
  name: 'curriculum-detail',
  data() {
    return {
      //页码管理
      page_no: 1,
      page_size: 10,
      total: 0,

      classid: '',
      currentpage: '1',
      teacherPlanList: [],
      class_stu_list: [],
      classInfo: {},
      subject_code: '',

      //学员密码重置
      form_stu: {
        password: '',
      },

      value: null,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
        date1: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        date2: [
          {
            type: 'date',
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'change',
          },
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' },
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',
      gridData: [
        {
          date: '9:31',
          name: '王小虎',
          address: '正常',
        },
        {
          date: '9:50',
          name: '王小虎',
          address: '迟到',
        },
        {
          date: null,
          name: '王小虎',
          address: '缺勤',
        },
      ],

      workData: [
        {
          date: '9:31',
          name: '王小虎',
          address: '未提交',
          comment: '未评',
        },
        {
          date: '9:50',
          name: '王小虎',
          address: '已提交',
          comment: '未评',
        },
        {
          date: null,
          name: '王小虎',
          address: '已提交',
          comment: '已评',
        },
      ],

      tableData: [
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
      ],
      activeName: 'first',
      radio1: '上海',
      radio: '3',
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      CourseWork: [], //课程作品
      markform: {
        markpoint: '',
        remark: '',
        is_good: false,
        is_only: false,
      }, //作品点评

      work_title: '', //项目名称
      work_url: '', //项目地址
      workinfo: {}, //预览的项目信息
      StuInfo: {},
      stu_name: '',
      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PYTHON作品点评
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高
      python_work_url: '',

      current_stu: {
        studentUserInfo: {
          realname: '',
        },
      }, //当前选中的学生
      //同步老学员作品
      sut_id: '5ed81abb73bf0c119431280e', //学员老系统作品
      dialogVisible2: false, //作品同步显示窗口
      dialogVisible3: false,
      userInfo: {}, //学员信息
      workslist: [], //学员作品信息
      stu_form: {
        username: '',
        stuId: '',
        steam_stuId: '',
      },

      curriculumMaterialList: [],
      curriculumInfo: {},
      colors: ['#f6dd25', '#f6dd25', '#f6dd25'],

      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      pageScrollTop: 0,
    }
  },
  mounted() {
    console.log('课程详情')
    console.log(this.curriculumInfo)
    this.getPrepareCurrculumMaterialList()
  },
  activated() {
    this.$nextTick(() => {
      const box = this.$refs.box
      if (box && this.$route.query.scrollToHeight) {
        const currentRoute = this.$route
        const routeQuery = JSON.parse(JSON.stringify(this.$route.query))
        box.scrollTo({
          top: routeQuery.scrollToHeight, // 目标位置的垂直偏移量
          behavior: 'instant', // 平滑滚动效果
        })
        console.log(routeQuery)
        this.$delete(routeQuery, 'scrollToHeight')
        this.$router.replace({ ...currentRoute, query: routeQuery })
      }
    })
  },
  methods: {
    goBack() {
      console.log('返回备课')
      this.$router.push({
        name: 'prepare-lessons',
        query: {
          subject_id: this.$route.query.subject_id,
          teaching_type: this.$route.query.teaching_type,
          course_type: this.$route.query.course_type,
        },
      })
    },

    getPrepareCurrculumMaterialList() {
      getPrepareCurrculumMaterialList({
        curriculum_id: this.$route.query.id,
      }).then((res) => {
        this.curriculumMaterialList = res.curriculumMaterialList
        this.curriculumInfo = res.curriculumInfo
        console.log(res)
      })
    },

    //重置学生密码
    updateStuUserPassword(row) {
      this.$confirm(`确定将密码重置为${this.$store.state.globalCheck.defaultPassword}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateStuUserPassword({
          stuId: row.id,
          password: CryptoJS.MD5(this.$store.state.globalCheck.defaultPassword).toString(
            CryptoJS.enc.Base64
          ),
        }).then((res) => {
          console.log('重置密码')
          console.log(res)
          this.$message.success('重置成功')
        })
      })
    },

    //根据讲次查询学员课堂作品和学员课后作业完成情况
    tchGetStuTchPlanListByTchId(tch_plan_id) {
      console.log('讲次相关作品查询')
      console.log(tch_plan_id)

      tchGetStuTchPlanListByTchId({
        tch_plan_id: tch_plan_id,
      }).then((res) => {
        console.log('查询讲次的课堂作品和作业作品')
        console.log(res)
        this.CourseWork = res.stuTchPlanList
        this.subject_code = res.subjectInfo.code
      })
    },

    getTchTeachingPlan() {
      getTchTeachingPlan({
        class_id: this.$route.query.class_id,
      }).then((res) => {
        console.log('获取班级对应的教学计划')
        console.log(res)
        this.teacherPlanList = res.teaching_plan_list
        this.classInfo = res.classInfo
        this.class_stu_list = res.class_stu_list
      })
    },

    //作品打分
    MarkWork(id, workinfo, stuinfo, subjectinfo) {
      this.work_title = workinfo.title
      this.work_url = workinfo.work_url
      this.workinfo = workinfo
      this.StuInfo = stuinfo
      this.stu_name = stuinfo.studentUserInfo.realname
      this.tch_work_id = workinfo.id

      this.subject_code = subjectinfo.code

      if (workinfo.is_marking) {
        this.markform = {
          is_good: workinfo.is_good,
          is_only: workinfo.is_only,
          markpoint: workinfo.markpoint,
          remark: workinfo.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }

      console.log(id)
      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)

      if (this.subject_code == '1') {
        this.dialogFormVisible1 = true
      } else if (this.subject_code == '2') {
        this.dialogFormVisible = true
      } else if (this.subject_code == '3') {
        this.dialogFormVisible2 = true
        console.log('PY课堂作品')
        let routeData = this.$router.resolve({
          name: 'python_course',
          query: {
            type: '2',
            title: workinfo.title,
            plan_id: workinfo.stu_tch_plan_id,
            operate: workinfo.work_type == '1' ? '2' : '4',
          },
        })

        this.python_work_url = routeData.href

        if (workinfo.work_type == '1') {
          this.$store.commit('SET_COURSE_WORK_URL', workinfo.work_url || '')
        } else {
          this.$store.commit('SET_HOME_WORK_URL', workinfo.work_url || '')
        }
      }
    },

    tchSaveTchWorkScore() {
      console.log('教师点评作品')
      console.log(this.markform)
      console.log(this.subject_code)

      tchSaveTchWorkScore({
        subject_code: this.subject_code,
        tch_work_id: this.tch_work_id,
        markpoint: this.markform.markpoint,
        remark: this.markform.remark,
        is_good: this.markform.is_good,
        is_only: this.markform.is_only,
      }).then((res) => {
        console.log('教师点评作品')
        console.log(res)
        if (res.is_update) {
          this.$message.success('点评成功')
          this.dialogFormVisible = false
          this.dialogFormVisible1 = false
          this.dialogFormVisible2 = false
          this.dialogFormVisible3 = false
        }
      })
    },

    onSubmit() {
      console.log('submit!')
    },
    handleClickTab(tab, event) {
      console.log(tab, event)
    },
    handleClick(row) {
      console.log(row)
    },

    handleEdit(row) {
      this.dialogFormVisible = true
      console.log(row)
    },

    goTeachlessons(item) {
      console.log('去上课')
      console.log(item)

      if (item.sign_state == '1') {
        console.log('课堂已解锁')
        this.$router.push({
          name: 'teachLessons',
          query: {
            curriculumMaterial_id: item.curriculum_meterial_id,
            backname: 'classlistIndexTeacher',
            classid: item.curriculum_class_id,
            teaching_plan_id: item.id,
          },
        })
      } else {
        this.$confirm(
          '点击开始上课后,本节课解锁成功,学员可以开始创作!',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          this.updateTchPlanSignState(item)
        })
      }
    },

    //更新教学计划的签到状态
    updateTchPlanSignState(item) {
      updateTchPlanSignState({
        teaching_plan_id: item.id,
      }).then((res) => {
        console.log('更新教学计划的签到状态')
        console.log(res)
        if (res.is_update) {
          this.$message.success('课程已解锁,可以开始上课啦!')
          this.$router.push({
            name: 'teachLessons',
            query: {
              curriculumMaterial_id: item.curriculum_meterial_id,
              backname: 'classlistIndexTeacher',
              classid: item.curriculum_class_id,
              teaching_plan_id: item.id,
            },
          })
        }
      })
    },

    prepare(item) {
      this.dialogVisible = false
      const box = this.$refs.box
      if (box) {
        const overflowHeightEl = box.children[0]
        this.pageScrollTop = Math.abs(
          overflowHeightEl.getBoundingClientRect().top - 60
        )
      }
      this.$router.push({
        name: 'prepare',
        query: {
          curriculumMaterial_id: item.id,
          backname: 'curriculum-detail',
          id: this.$route.query.id,
          scrollToHeight: this.pageScrollTop,
        },
      })
    },

    handleCurrentPlanPage(val) {
      this.page_no = val
      this.getTchTeachingPlan()
    },

    //同步学员数据
    getStuWorksInfo(row) {
      this.dialogVisible3 = true
      this.stu_form.steam_stuId = row.id
    },

    getStuScratchWorks() {
      if (!this.stu_form.stuId) {
        this.$message.warning('请填写原学生码')
        return
      }

      if (!this.stu_form.username) {
        this.$message.warning('请填写原账号')
        return
      }

      var that = this

      if (this.classInfo.subject_id == 1) {
        console.log('查询学员JR作品')

        getStuJrcodeWorks(this.stu_form.stuId, this.stu_form.username, function (
          res
        ) {
          console.log('学员Jrcode系统作品')
          console.log(res)

          if (res.status == 'success') {
            that.userInfo = res.userInfo
            that.workslist = res.dataArr
            that.dialogVisible2 = true

            for (let k = 0; k < that.workslist.length; k++) {
              console.log(that.workslist[k].zan)
              if (that.workslist[k].zan !== undefined) {
                that.workslist[k].work_type = '2'
              } else {
                that.workslist[k].work_type = '1'
              }
            }
          } else if (res.status == 'fail') {
            that.$notify({
              title: '警告',
              message: res.msg,
              type: 'warning',
            })
          }
        })
      } else if (this.classInfo.subject_id == 2) {
        console.log('查询学员SC作品')

        getStuScratchWorks(
          this.stu_form.stuId,
          this.stu_form.username,
          function (res) {
            console.log('学员scratch3系统作品')
            if (res.status == 'success') {
              that.userInfo = res.userInfo
              that.workslist = res.dataArr

              for (let k = 0; k < that.workslist.length; k++) {
                console.log(that.workslist[k].zan)
                if (that.workslist[k].zan !== undefined) {
                  that.workslist[k].covers =
                    'https://scratch3.fun/released/covers/' +
                    that.workslist[k].covers

                  that.workslist[k].work_url =
                    'https://scratch3.fun/scratch/download/released/' +
                    that.workslist[k].worksid
                  that.workslist[k].work_type = '2'
                } else {
                  that.workslist[k].covers =
                    'https://scratch3.fun/unreleased/covers/' +
                    that.workslist[k].covers
                  that.workslist[k].work_url =
                    'https://scratch3.fun/scratch/downloads?fileid=' +
                    that.workslist[k].localsname
                  that.workslist[k].work_type = '1'
                }
              }

              console.log('组合后的作品列表')
              console.log(that.workslist)

              that.dialogVisible2 = true
            } else if (res.status == 'fail') {
              that.$notify({
                title: '警告',
                message: res.msg,
                type: 'warning',
              })
            }
          }
        )
      }
    },
    //同步SC作品
    saveOldSysWork() {
      var workArr = []
      var work = {}

      if (this.classInfo.subject_id == 1) {
        console.log('同步JR作品')
        if (this.workslist.length == 0) {
          this.$message.warning('无可同步的数据')
          return
        } else {
          for (let k = 0; k < this.workslist.length; k++) {
            console.log(this.workslist[k])
            work = {
              work_url: this.workslist[k].work_url,
              covers: this.workslist[k].cover_url,
              title: this.workslist[k].title,
              abstract: this.workslist[k].abstract,
              explain: this.workslist[k].explain,
              is_only: this.workslist[k].is_only,
              work_type: this.workslist[k].work_type,
            }
            workArr.push(work)
          }
        }

        console.log('同步数据提交的参数')
        console.log(workArr)
        console.log(work)

        saveOldSysJrWork({
          stuId: this.stu_form.steam_stuId,
          workArr: JSON.stringify(workArr),
        }).then((res) => {
          console.log('同步JR作品')
          console.log(res)
          if (res.is_create) {
            this.$message.success('数据同步完成')
            this.stu_form.username = ''
            this.stu_form.stuId = ''
            this.stu_form.steam_stuId = ''
            this.dialogVisible3 = false
            this.dialogVisible2 = false
          }
        })
      } else if (this.classInfo.subject_id == 2) {
        console.log('同步SC作品')
        if (this.workslist.length == 0) {
          this.$message.warning('无可同步的数据')
          return
        } else {
          for (let k = 0; k < this.workslist.length; k++) {
            console.log(this.workslist[k])
            work = {
              work_url: this.workslist[k].work_url,
              covers: this.workslist[k].covers,
              title: this.workslist[k].title,
              abstract: this.workslist[k].abstract,
              explain: this.workslist[k].explain,
              is_only: this.workslist[k].isOnly,
              work_type: this.workslist[k].work_type,
            }
            workArr.push(work)
          }
        }

        console.log('同步数据提交的参数')
        console.log(workArr)
        console.log(work)

        saveOldSysScWork({
          stuId: this.stu_form.steam_stuId,
          workArr: JSON.stringify(workArr),
        }).then((res) => {
          console.log('同步SC作品')
          console.log(res)
          if (res.is_create) {
            this.$message.success('数据同步完成')
            this.stu_form.username = ''
            this.stu_form.stuId = ''
            this.stu_form.steam_stuId = ''
            this.dialogVisible3 = false
            this.dialogVisible2 = false
          }
        })
      }
    },
  },
}
</script>

<style>
.el-dialog {
  width: 900px;
}
.v-show-content {
  background: white !important;
}
</style>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: scroll;
  .school-body {
    padding: 10px;

    .classwrapper {
      border-radius: 5px;
      background: white;

      .classheader {
        margin-top: 15px;
        margin-left: 15px;
      }
      .classlist {
        padding-left: 20px;
        .classlist_wrapper {
          padding-top: 20px;
          padding-bottom: 20px;
          .classlist-imgwrapper {
            width: 100%;

            .classimg_wrapper_img {
              width: 100%;
              border-radius: 5px;
            }
          }
          .classlist-content {
            .classlist-content-title {
              padding-left: 40px;
              font-weight: 500;
              line-height: 40px;
              font-size: 14px;
              .coursetitle {
                padding-right: 10px;
                font-weight: bold;
                font-size: 14px;
              }
            }
            .classlist-content-desc {
              padding-left: 40px;
              padding-right: 40px;

              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;

              .content-desc {
                padding-right: 20px;
              }
            }
          }
          .classlist-btn {
            margin-top: 15%;
          }
        }

        .classlist_wrapper::-webkit-scrollbar {
          /*隐藏滚轮*/
          display: none;
        }
      }
      .classimg_wrapper {
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 5px 5px;
      }
      .classdesc_wrapper {
        margin-left: 40px;
        .classdesc_title {
          font-size: 20px;
          padding-bottom: 10px;
        }
      }
    }
  }
}
</style>
